import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import mapLoyaltyAccount from 'api/mappers/loyalty/mapLoyaltyAccount'
import requestUtils, { authOptions } from 'api/requestUtils'

type Response = paths['/api/lux-loyalty/account/me']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyAccount(token?: string) {
  const response = await requestUtils.get<Response>('/api/lux-loyalty/account/me', authOptions(token))

  return mapLoyaltyAccount(response.result)
}

export default requestLoyaltyAccount
